import React, { memo, useEffect, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import CustomModal from "../../../layouts/Modal";
import Button from "../../../common/Button";
import lp from "../../../assets/icons/stayUsdc.png";
import image1 from "../../../assets/images/progress2_1.png";
import image2 from "../../../assets/images/progress2_2.png";
import image3 from "../../../assets/images/progress2_3.png";
import image4 from "../../../assets/images/progress2_4.png";
import image5 from "../../../assets/images/progress2_5.png";
import { useNfstay } from "../../../context/ThemeContext";
import toast from "react-hot-toast";
import BLoader from "../../../common/BLoader";
import { ethers } from "ethers";

const BNBLiquidity = ({ maxBalance, setInputVal, inputVal, onHide }) => {
  const [isExploding, setIsExploding] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [status, setStatus] = useState({ isZap: false, isApproved: false, isDeposit: false });
  const [showLast, setShowLast] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [isLoadingDeposit, setIsLoadingDeposit] = useState(false);
  const [depositValue, setDepositValue] = useState("");
  const { checkTokenApprovalToZapper, Farming_stakeLps, zapper_swapping, approveToZapper } =
    useNfstay();

  useEffect(() => {
    if (status.isZap && status.isApproved && status.isDeposit) {
      setIsExploding(true);
      setShowLast(true);
      setTimeout(() => {
        onHide();
      }, 2000);
    }
  }, [status]);

  const handleDeposit = async () => {
    try {
      setIsLoadingDeposit(true);
      await Farming_stakeLps(depositValue);
      toast.success("Transaction Successful");
      setDepositValue("");
      setInputVal("");
      status.isApproved && setStatus(prev => ({ ...prev, isDeposit: true }));
    } catch (e) {
      toast.error(e.reason || e.message || "Something went wrong");
    } finally {
      setIsLoadingDeposit(false);
    }
  };

  const approveLP = async asset => {
    try {
      setIsLoadingApprove(true);
      await approveToZapper(asset);

      status.isZap && setStatus(prev => ({ ...prev, isApproved: true }));
      setIsApproved(true);
    } catch (e) {
      console.log(e);
      toast.error(e.reason || e.message || "Something went wrong");
    } finally {
      setIsLoadingApprove(false);
    }
  };

  const handleZapIn = async () => {
    try {
      setIsLoading(true);
      // value = 0.001
      const tx = await zapper_swapping("BNB", inputVal);

      setDepositValue(tx);

      await maxBalance("BNB");

      const res = await checkTokenApprovalToZapper("LP");
      if (res) {
        setStatus(prev => ({ ...prev, isZap: true, isApproved: true }));
      } else {
        setStatus(prev => ({ ...prev, isZap: true }));
      }
    } catch (e) {
      // toast.error("here", inputVal);

      toast.error(e.reason || e.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CustomModal
      title="Stake To Earn"
      onHide={onHide}
    >
      {isExploding && (
        <div className="flex justify-center">
          <ConfettiExplosion
            particleCount={500}
            zIndex={999999}
          />
        </div>
      )}
      <div className="pl-4 relative">
        {!showLast ? (
          <img
            className="absolute -left-1 md:-left-2 h-[253px] sm:h-[289px] top-[3px]"
            src={
              !status.isZap && !status.isApproved && !status.isDeposit
                ? image1
                : status.isZap && !status.isApproved && !status.isDeposit
                  ? image2
                  : status.isZap && status.isApproved && !status.isDeposit
                    ? image3
                    : status.isZap && status.isApproved && status.isDeposit
                      ? image4
                      : image5
            }
            alt="step"
          />
        ) : (
          <img
            className="absolute -left-3 md:-left-2 h-[392px] sm:h-[358px] top-[3px]"
            src={image5}
            alt="step"
          />
        )}
        <div>
          <div className="flex justify-between items-center mb-2">
            <div>
              <p className="text-main font-bold">Create LP Token</p>
            </div>
            <span className="max-sm:text-sm text-main opacity-70 font-medium">Step 1</span>
          </div>
          <Button
            className="w-full flex items-center gap-2 justify-center text-main"
            style={{
              color: status.isZap ? "var(--main)" : "#FFFFFF",
              background: status.isZap
                ? `linear-gradient(90.57deg, rgba(153, 69, 255, 0.2) 0%, rgba(32, 225, 159, 0.2) 100%)`
                : "var(--primary)",
            }}
            onClick={handleZapIn}
            disabled={isLoadingDeposit || isLoading || isLoadingApprove || status.isZap}
          >
            {isLoading ? <BLoader /> : "ZAP IN ⚡️"}
          </Button>
        </div>
        <div>
          <div className="flex justify-between items-center mb-2">
            <div>
              <p className="text-main font-bold">Approve LP Token</p>
            </div>
            <span className="max-sm:text-sm text-main opacity-70 font-medium">Step 2</span>
          </div>
          <Button
            onClick={() => approveLP("LP")}
            className="w-full flex items-center gap-2 justify-center text-main"
            style={{
              color: !status.isApproved && status.isZap ? "#FFFFFF" : "var(--main)",
              background:
                status.isZap && !status.isApproved
                  ? "var(--primary)"
                  : `linear-gradient(90.57deg, rgba(153, 69, 255, 0.2) 0%, rgba(32, 225, 159, 0.2) 100%)`,
            }}
            disabled={
              isLoadingDeposit ||
              isLoading ||
              isLoadingApprove ||
              !status.isZap ||
              status.isApproved
            }
          >
            {isLoadingApprove ? (
              <BLoader />
            ) : (
              <>
                {!status.isApproved ? (
                  <>
                    <img
                      src={lp}
                      alt="lp"
                    />{" "}
                    Approve LP Token
                  </>
                ) : (
                  "Approved"
                )}
              </>
            )}
          </Button>
        </div>

        <div className="mt-3">
          <div className="flex justify-between items-start mb-2">
            <div>
              <p className="text-main font-bold">Deposit LP Token</p>
            </div>
            <span className="max-sm:text-sm text-main opacity-70 font-medium">Step 3</span>
          </div>
          <Button
            className={`w-full flex items-center gap-2 justify-center border border-primary text-main`}
            style={{
              color:
                status.isApproved && status.isZap && !status.isDeposit ? "#FFFFFF" : "var(--main)",
              background:
                status.isZap && status.isApproved && !status.isDeposit
                  ? "var(--primary)"
                  : `linear-gradient(90.57deg, rgba(153, 69, 255, 0.2) 0%, rgba(32, 225, 159, 0.2) 100%)`,
            }}
            onClick={handleDeposit}
            disabled={
              isLoadingDeposit ||
              isLoading ||
              isLoadingApprove ||
              !status.isZap ||
              !status.isApproved ||
              status.isDeposit
            }
          >
            {isLoadingDeposit ? (
              <BLoader />
            ) : (
              <>
                <img
                  src={lp}
                  alt="lp"
                />
                Deposit LP Token
              </>
            )}
          </Button>
        </div>
        <div className="mt-3">
          <div className="flex justify-between items-start mb-2">
            <div>
              <p className="text-main font-bold">Success</p>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default memo(BNBLiquidity);
